export default __webpack_public_path__ + "static/media/13.47.4521cce0.jpg";